import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CustomDataGrid from "../../../Components/CustomDataGrid/CustomDataGrid";
import CustomBackdrop from "../../../Components/CustomBackdrop/Barckdrop";
import {
  blackColor,
  defaultFont,
  grayColor,
} from "../../../assets/jss/psstyle/psacount";
import axios from "axios";
import { genURL, genURLTEST } from "../../../_getjson";
import moment from "moment";
import "moment/locale/th";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Button, Tab, Grid } from "@mui/material";
import CustomInput from "../../../Components/CustomInput/CustomInput";
import CustomDateRangePicker from "../../../Components/CustomDatepicker/CustomDateRangePicker";
import CustominputRang from "../../../Components/CustomInput/CustominputRang";
import CustomSiteCodeInput from "../../../Components/CustomSiteCode/customsitecodeinput";
import ConditionSelectProduct from "../../../Components/ConditionSearch/Components/ConditionSelectProduct";

const columns = [
  { field: "id", headerName: "id", width: 40, hide: true },
  {
    field: "docDate",
    headerName: "วันที่ขอโอน",
    width: 150,
    editable: false,
  },
  {
    field: "docNo",
    headerName: "ใบขอโอน",
    width: 220,
    editable: false,
  },
  {
    field: "remark",
    headerName: "หมายเหตุ",
    editable: false,
    flex: 1,
  },
];
export default function Rechecked(props) {
  const { from } = props;
  const [openbackdrop, setopenbackdrop] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [tabValue, setTabValue] = React.useState("1");
  const [state, setState] = React.useState({
    dateStart: "",
    dateEnd: "",
    docNoStart: "",
    docNoEnd: "",
    siteCode: "",
    productBrand: "",
    productColor: "",
    productMainGroup: "",
    productModel: "",
    productStatus: "",
    productType: "",
    productTableData: [],
    top: "100",
  });

  React.useEffect(() => {
    console.log("res state ", state);
    return () => {};
  }, [state]);
  const loadData = async (ConditionData) => {
    setopenbackdrop(true);
    let url = "";
    // if (val === 'all') {
    // url = `CSPURCHASE/Search?top=100&startdate=${datestartdata != null ? datestartdata : ""}&enddate=${dateenddata != null ? dateenddata : ""}&startdocno=${docnostartdata != null ? docnostartdata : ""}&enddocno=${docnoenddata != null ? docnoenddata : ""}`
    // } else {
    url = `CSSTKMOVE/SearchData?ConditionData=${ConditionData}`;
    // }
    let rs = await axios.get(genURL(url));
    // let rs = await axios.get(genURLTEST(`/SearchData?ConditionData=${ConditionData}`))
    let element = [];
    if (rs.data.length > 0) {
      console.log("rs", rs.data);
      for (let index = 0; index < rs.data.length; index++) {
        element.push({
          id: Number(index) + 1,
          docDate: moment(rs.data[index].DOCDATE).format("L"),
          docNo: rs.data[index].DOCNO,
          remark: rs.data[index].REMARK,
          fontColor: rs.data[index].FONTCOLOR,
        });
      }
      await setRows(element);
    } else {
      await setRows([]);
    }
    await setopenbackdrop(false);
  };
  const resData = (e) => {
    console.log("resData resData", e);
  };
  const removeresData = (e) => {
    console.log("resData removeresData", e);
  };
  const selcetRow = async (e) => {
    console.log("selcetRow", e);
    await props.Dataselect(e);
  };
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const resInput = async (source, value) => {
    console.log("resInput", value);
    // if (source === "DocNo") {

    if (source === "docNo") {
      setState({
        ...state,
        ["docNoStart"]: value.docNoStart,
        ["docNoEnd"]: value.docNoEnd,
      });
    } else if (source === "siteCode") {
      setState({
        ...state,
        ["siteCode"]: value,
      });
    } else if (source === "docDate") {
      setState({
        ...state,
        ["dateStart"]: value.docNoStart,
        ["dateEnd"]: value.docNoEnd,
      });
    }
  };

  const resultCondition = async (source, value) => {
    console.log("source", value);
    if (source === "productData") {
      await setState({
        ...state,
        productBrand: value.productBrand,
        productColor: value.productColor,
        productMainGroup: value.productMainGroup,
        productModel: value.productModel,
        productStatus: value.productStatus,
        productType: value.productType,
        productTableData: value.productTableData,
      });
    }
    //  await console.log('resultCondition', state)
  };
  const handleSearchClick = async () => {
    let ConditionData = await JSON.stringify([
      {
        StartDate:
          state.dateStart === ""
            ? ""
            : state.dateStart === null
            ? ""
            : DateConvertByMoment(state.dateStart),
        EndDate:
          state.dateEnd === ""
            ? ""
            : state.dateEnd === null
            ? ""
            : DateConvertByMoment(state.dateEnd),

        StartDocNo: state.docNoStart,
        EndDocNo: state.docNoEnd,
        ProductBrand: state.productBrand,
        ProductColor: state.productColor,
        ProductMainGroup: state.productMainGroup,
        ProductModel: state.productModel,
        ProductStatus: state.productStatus,
        ProductType: state.productType,
        ProductTableData: JSON.stringify(state.productTableData),
        Top: state.top,
      },
    ]);
    await loadData(ConditionData);
  };
  const handleRowClick = (e) => {
    //  console.log("handleRowClick", e)
    props.Dataselect(e.row);
  };
  return (
    <React.Fragment>
      <CssBaseline />
      <Container maxWidth="xl">
        <Box sx={{ height: 500, width: "100%" }}>
          <Grid container spacing={1}>
            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
              <Button
                variant="outlined"
                startIcon={<SearchRoundedIcon />}
                sx={{
                  pt: -5,
                  height: "32px",
                  mt: 1.4,
                  borderColor: grayColor[11],
                  color: blackColor[0],
                  fontFamily: defaultFont,
                }}
                onClick={() => handleSearchClick()}
                size="small"
              >
                ค้นหา
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomInput
                inputType={"number"}
                id={"rowSelect"}
                label={`จำนวนรายการ`}
                placeholder={
                  "ถ้าต้องการรายการทั้งหมดตามเงื่อนไขให้กรอก -1 ค่าเริ่มต้นเป็น 100"
                }
                resData={(e) =>
                  setState({
                    ...state,
                    top: e,
                  })
                }
              />
            </Grid>
          </Grid>

          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabContext value={tabValue}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab label="เงื่อนไข" value="1" />
                  <Tab label="สินค้า" value="2" />
                </TabList>
              </Box>
              <TabPanel value="1">
                <Grid container spacing={3}>
                  <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
                    <CustomDateRangePicker
                      label={"วันที่"}
                      resData={(e) => resInput("docDate", e)}
                      defaultValue={state}
                    />
                  </Grid>
                  <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
                    <CustominputRang
                      label={"เลขที่เอกสาร"}
                      resData={(e) => resInput("docNo", e)}
                      inputType={"text"}
                      keyDown={(e) => keyDown(e)}
                      defaultValue={state}
                    />
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value="2">
                <ConditionSelectProduct
                  result={(e) => resultCondition("productData", e)}
                  defaultValue={state}
                />
              </TabPanel>
            </TabContext>
          </Box>
          {rows.length > 0 ? (
            <CustomDataGrid
              datacolumns={columns}
              datarows={rows}
              rowHeight={38}
              Dataintable={(e) => resData(e)}
              Dataintableremove={(e) => removeresData(e)}
              startRow={1}
              option={[{ add: false, del: false, select: true }]}
              // checkboxSelection
              onRowClick={(e) => selcetRow([e.row])}
              disableColumnSelector
              // Dataselect={e => selcetRow(e)}
              RowsModelChange={(_) => console.log("RowsModelChange")}
              from={from}
            />
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign={"center"}>
                ไม่พบข้อมูล
              </Grid>
            </Grid>
          )}
          <CustomBackdrop open={openbackdrop} />
        </Box>
      </Container>
    </React.Fragment>
  );
}
